module.exports = __webpack_public_path__ + "img/i4.c32b7ff1.png";